import { Container } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import PermissionBasedGuard from 'src/auth/guard/permission-based-guard';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs/custom-breadcrumbs';
import OrderListView from 'src/sections/orders/view/order-list-view';


// ----------------------------------------------------------------------

export default function Deliveries() {
    return (

        <>
            <Helmet>
                <title> Dashboard: Deliveries</title>
            </Helmet>
            <Container maxWidth={false}>

                <PermissionBasedGuard permissions={['partners:read:deliveries']}>
                    <CustomBreadcrumbs
                        heading="Deliveries"
                        links={[{},]}

                        sx={{ mb: 2 }}
                    />
                    <OrderListView />
                </PermissionBasedGuard>
            </Container>

        </>
    );
}
